import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { motion } from '@/lib/motion';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative w-10 h-10 rounded-lg glass flex items-center justify-center group overflow-hidden hover:shadow-lg hover:shadow-sand/20 transition-shadow duration-200"
      whileHover={{ scale: 1.1, rotate: 15 }}
      whileTap={{ scale: 0.9, rotate: -15 }}
      aria-label={theme === 'day' ? 'التبديل إلى الوضع الليلي' : 'التبديل إلى وضع النهار'}
    >
      {/* Glow effect on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-sand/0 via-sand/20 to-sand/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl" />
      <motion.div
        initial={false}
        animate={{
          rotate: theme === 'day' ? 0 : 180,
          scale: theme === 'day' ? 1 : 0
        }}
        transition={{ duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }}
        className="absolute"
      >
        <Sun className="w-6 h-6 text-sand" />
      </motion.div>
      <motion.div
        initial={false}
        animate={{
          rotate: theme === 'night' ? 0 : -180,
          scale: theme === 'night' ? 1 : 0
        }}
        transition={{ duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }}
        className="absolute"
      >
        <Moon className="w-6 h-6 text-sand" />
      </motion.div>
    </motion.button>
  );
};
